<template>
  <b-container fluid class="pa-0">
    <v-toolbar flat scroll-off-screen class="elevation-1 pr-4 pl-0 bk-color-as">
      <router-link to="/">
        <img
          src="https://www.allseasons.tur.ar/ws/utiles/img/logo.png"
          alt="All Seasons"
          id="logo-as"
        />
      </router-link>

      <v-spacer></v-spacer>
      <span
        class="body-2 cur-pointer px-3 white--text"
        style="padding-top: 3px;"
        v-if="!$vuetify.breakpoint.smAndDown"
        @click="$router.push('/')"
        >INICIO</span
      >
      <span
        class="body-2 cur-pointer white--text"
        style="padding-top: 3px;"
        @click="_$goToUrl('https://comunidad.allseasons.com.ar/')"
        v-if="!$vuetify.breakpoint.smAndDown"
        >COMUNIDAD</span
      >
      <v-menu
        :nudge-width="100"
        v-if="!$vuetify.breakpoint.smAndDown && btnsLogIn"
      >
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span class="body-2 white--text">PAGOS</span>
            <v-icon dark small style="line-height: 21px;" class="ml-1"
              >fas fa-sort-down</v-icon
            >
          </v-toolbar-title>
        </template>

        <v-list>
          <v-list-tile>
            <v-list-tile-title class="cur-pointer" @click="promociones = true"
              >Promociones w</v-list-tile-title
            >
          </v-list-tile>
          <v-list-tile v-if="false">
            <v-list-tile-title class="cur-pointer" @click="goToPago()"
              >Pagar</v-list-tile-title
            >
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title class="cur-pointer" @click="cambio = true"
              >Tipo de cambio</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="100"
        offset-x
        v-if="btnsLogIn"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon color="orange darken-1" small>
              {{ $vuetify.breakpoint.smAndDown ? "reorder" : "fas fa-user" }}
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list v-if="$vuetify.breakpoint.smAndDown">
            <v-list-tile>
              <v-list-tile-title
                class="cur-pointer text-xs-center"
                @click="promociones = true"
                >Promociones x</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile v-if="false">
              <v-list-tile-title
                class="cur-pointer text-xs-center"
                @click="goToPago()"
                >Pagar</v-list-tile-title
              >
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-title
                class="cur-pointer text-xs-center"
                @click="cambio = true"
                >Tipo de cambio</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="text-xs-center">
                  {{ usuario.agencia }}
                </v-list-tile-title>
                <v-list-tile-sub-title class="text-xs-center">
                  {{ usuario.usuario }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn flat color="red" @click="cerrarSession">Cerrar sesión</v-btn>
            <v-btn flat color="primary" @click="menu = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-layout row justify-center>
      <v-dialog
        v-model="promociones"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="red darken-4">
            <img
              src="https://www.allseasons.tur.ar/ws/utiles/img/logo.png"
              alt="All Seasons"
              id="logo-as"
            />
            <v-spacer></v-spacer>
            <v-btn icon dark @click="promociones = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <allseasons-promociones v-if="promociones"></allseasons-promociones>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-dialog v-model="cambio" max-width="600" v-show="cambio">
      <v-card>
        <v-toolbar dark class="bk-color-as">
          <p class="mb-0 title">Tipo de cambio</p>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="cambio = false">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <Cotizaciones></Cotizaciones>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import AxiosHandler from "@/assets/js/class/AxiosHandler.js";
import Cotizaciones from "@/components/utiles/Cotizaciones.vue";
export default {
  created() {},
  components: {
    Cotizaciones
  },
  mounted() {
    this.$store.dispatch(
      "app/guardarUsuario",
      this.$passporthandler.getDatosUsuarios()
    );
  },
  methods: {
    setDatosUsuario() {
      this.showIconUsr = false;
      if (
        this.usuario.usuario != undefined ||
        this.usuario.agencia != undefined
      ) {
        this.showIconUsr = true;
      }
    },
    cerrarSession() {
      this.$passporthandler.removePassport();
      this.$cookies.remove("auth");
      this.$store.dispatch("app/guardarUsuario", false);
      this.$router.replace({
        name: "login",
        params: { comefrom: this.$router.currentRoute.name }
      });
      //this.setDatosUsuario();
    },
    async isLogued() {
      let logued = await this.$passporthandler.isAuth();
      if (!logued.auth) {
        this.$router.replace({ name: "login" });
      }
    },
    async goToPago() {
      const rq = this.armarRqUrlPago();
      var header = this.$passporthandler.prepareHeader();
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" });
      }
      let axios = new AxiosHandler();
      axios.setPassportHandler(this.$passporthandler);
      axios.prepare(
        process.env.VUE_APP_ASBACK + "/api/urlintpagomotorweb-apps",
        header,
        rq
      );
      axios.overlay(false);
      await axios.exe();
      this.manenoJsUrlPago(axios.getData(), axios.getStatus());
    },
    armarRqUrlPago() {
      const rq = {
        btn_back: `${process.env.VUE_APP_ASBACK}/redirect/0`,
        user_id_web: this.usuario.id,
        nombre_ope: this.usuario.usuario,
        returnURL: null, //`${process.env.VUE_APP_ASBACK}/redirect/0`, // A modificar una vez esté definido a donde retornar el status del pago
        email_ope: this.usuario.email,
        tipo_pago: 1, // Compre en linea 1 / autorizacion 2
        user_id_int: null,
        monto_ipmw: null,
        tiposerviciopmw: 3, // 0 todo los servicios,
        tipocaso: 0, // 0 valida file en el asback, 1 No valida file (pasa monto y tipo de servicio)
        id_agencia: this.usuario.idagencia,
        nombre_agencia: this.usuario.agencia,
        pago_in: 80
      };
      return rq;
    },
    manenoJsUrlPago(data, status) {
      if (status == 200) {
        window.location.href = data.url;
        return;
      }
      this.showToasted(
        "Ocurrio un error iniciando el motor de pagos, por favor intente nuevamente, en caso de persistir, contacte al administaodr",
        "error",
        2000
      );
    },
    goToRegion(region) {
      this.$router.replace({ name: "region", params: { region: region } });
    }
  },
  data() {
    return {
      menu: false,
      promociones: false,
      cambio: false
    };
  },
  computed: {
    ...mapGetters("app", {
      usuario: "getUsuario",
      appsAll: "getAllApp",
      regiones: "getRegiones"
    }),
    btnsLogIn() {
      switch (this.$route.name) {
        case "mensaje":
          return false;
        default:
          return true;
      }
    }
  },

  watch: {
    usuario(newValue) {
      let estaOk = false;
      const valids = [
        "usuario",
        "agencia",
        "email",
        "id",
        "idagencia",
        "nivel",
        "uws"
      ];
      try {
        const keys = Object.keys(this.usuario);
        estaOk = valids.every(v => {
          return keys.some(k => v === k);
        });
      } catch (error) {
        console.log(error);
      } finally {
        if (!estaOk) {
          this.$router.replace({ name: "login" });
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mt-100 {
  margin-top: 100px;
}
#logo-as {
  width: 110px;
}
.top-nav-as {
  background-color: black;
}
.nav-bar-as {
  padding: 0;
}
#disney-icon-as {
  width: 17px;
}
</style>
